import Link from 'next/link'
import { Fragment } from 'react'
import ReactCountryFlag from 'react-country-flag'
import { Artist } from 'utils/data'
import { getArtistUrl } from 'utils/urls'

type Props = {
  className?: string
  linkClassName?: string
  clickable?: boolean
  artists: Artist[]
}

export const ArtistsNames = ({
  className,
  linkClassName,
  clickable = true,
  artists,
}: Props) => {
  return (
    <div
      className={`flex flex-wrap items-center justify-start space-x-2  text-xl ${className}`}
    >
      {artists.map((artist, index) => (
        <Fragment key={index}>
          <div
            className={`inline-flex items-center  sm:text-lg md:text-xl ${linkClassName}`}
          >
            {index >= 1 && <span className='mr-2 text-cool-600'> x </span>}
            {clickable && (
              <Link
                href={getArtistUrl(artist.name, artist.id)}
                className='capitalize text-cool-600 duration-200 ease-in-out hover:text-secondary-default'
              >
                {artist.name}
              </Link>
            )}

            {!clickable && (
              <span className='capitalize text-cool-600 duration-200 ease-in-out'>
                {artist.name}
              </span>
            )}

            {artist?.nationality?.alpha2Code && (
              <ReactCountryFlag
                countryCode={artist.nationality.alpha2Code}
                svg
              />
            )}
          </div>
        </Fragment>
      ))}
    </div>
  )
}
